import { EmptyState } from '@gorila-shared-ui/components';
import { StyledHead, StyledHeadCell, StyledTable } from 'baseui/table';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeList as List } from 'react-window';
import { SMALL_LIST_ITEM_HEIGHT } from '../../../constants/app';
import { EXTENDED_TELEMETRY_EVENTS_COLUMNS, TELEMETRY_EVENTS_COLUMNS } from '../../../constants/reports';
import { useStyles } from '../../../hooks/useStyles';
import { HistoricTelemetry } from '../../../types/currentState';
import TelemetryReportRow from './TelemetryReportRow';
import { useEffect } from 'react';
import { useResetRecoilState } from 'recoil';
import { selectedReportRowState } from '../../../storage/reports';

type Props = {
  states?: HistoricTelemetry[];
  extended?: boolean;
};

export function TelemetryReportTable({ states, extended = false }: Props) {
  const { styles } = useStyles();
  const resetSelectedReportRowState = useResetRecoilState(selectedReportRowState);
  
    useEffect(() => {
      return () => {
        resetSelectedReportRowState();
      };
    }, []);

  if (!states?.length) {
    return <EmptyState title="No cuenta con registros de telemetría." />;
  }

  return (
    <StyledTable>
      <StyledHead $width={extended ? '800px' : undefined}>
        {(extended ? EXTENDED_TELEMETRY_EVENTS_COLUMNS : TELEMETRY_EVENTS_COLUMNS).map((column, index) => (
          <StyledHeadCell
            key={index}
            style={{
              flex: column.size,
              maxWidth: column.maxWidth ? `${column.maxWidth}px` : undefined,
              justifyContent: column.centered ? 'center' : undefined,
              ...styles.smallTableCellHeader,
            }}
          >
            {column.title}
          </StyledHeadCell>
        ))}
      </StyledHead>
      <div style={{ flex: 1, minHeight: '250px', width: extended ? '800px' : undefined }}>
        <AutoSizer>
          {({ width, height }) => (
            <List
              height={height}
              itemCount={states.length}
              itemSize={() => SMALL_LIST_ITEM_HEIGHT}
              width={width}
              itemData={{ states, extended }}
            >
              {TelemetryReportRow}
            </List>
          )}
        </AutoSizer>
      </div>
    </StyledTable>
  );
}
